"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var BillingApiTransactionResponseDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiTransactionResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_account_response_dto_1 = require("../../../billing-api-account/types/dtos/billing-api-account-response.dto");
const billing_core_ledger_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-ledger-type.enum");
const billing_core_transaction_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-transaction-type.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const key_value_1 = require("../../../../shared/types/key-value");
const swagger_1 = require("../../../../swagger-fake");
const types_1 = require("../../../billing-api-operation/types");
let BillingApiTransactionResponseDto = BillingApiTransactionResponseDto_1 = class BillingApiTransactionResponseDto {
  static fromTransaction(transaction) {
    const result = (0, class_transformer_1.plainToInstance)(BillingApiTransactionResponseDto_1, {
      ...transaction,
      ...(transaction.account ? {
        currencyCode: transaction.type === billing_core_transaction_type_enum_1.BillingCoreTransactionTypeEnum.PURCHASE ? transaction.payment?.currencyCode || transaction.account?.currencyCode : "USD"
      } : null)
    });
    return result;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id проводки",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id операции",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "operationId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id счёта",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Обменный курс",
  format: "decimal"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "rate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма",
  format: "decimal"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта счёта",
  format: "^[A-Z]{3}$",
  example: "USD"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Тип",
  enum: billing_core_transaction_type_enum_1.BillingCoreTransactionTypeEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_transaction_type_enum_1.BillingCoreTransactionTypeEnum), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Направление",
  enum: billing_core_ledger_type_enum_1.BillingCoreLedgerTypeEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_ledger_type_enum_1.BillingCoreLedgerTypeEnum), __metadata("design:type", String)], BillingApiTransactionResponseDto.prototype, "ledgerType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Meta-данные",
  type: () => key_value_1.Metadata,
  example: {
    chargeId: "f4c92982-1437-4c66-80a2-2bfd164584ed"
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), __metadata("design:type", Object)], BillingApiTransactionResponseDto.prototype, "meta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiTransactionResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Объект счёта (если запрошено явно; joined-свойство)",
  type: () => billing_api_account_response_dto_1.BillingApiAccountResponseDto,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), (0, class_transformer_1.Type)(() => billing_api_account_response_dto_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiTransactionResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Объект операции (если запрошено явно; joined-свойство)",
  type: () => types_1.BillingApiOperationResponseDto,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), (0, class_transformer_1.Type)(() => types_1.BillingApiOperationResponseDto), __metadata("design:type", Object)], BillingApiTransactionResponseDto.prototype, "operation", void 0);
BillingApiTransactionResponseDto = BillingApiTransactionResponseDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiTransactionResponseDto);
exports.BillingApiTransactionResponseDto = BillingApiTransactionResponseDto;
